module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[11]498.d93d694.woff2";